export class SftpKey {
  id: number;
  label: string;
  key_type: string;
  fingerprint: string;
  create_date: string;

  constructor() {
    this.id = -1;
    this.label = '';
    this.key_type = '';
    this.fingerprint = '';
    this.create_date = '';
  }

  static fromJson(data: any): SftpKey {
    const key = new SftpKey();
    key.id = data?.id ?? -1;
    key.label = data?.label ?? '';
    key.key_type = data?.key_type ?? '';
    key.fingerprint = data?.fingerprint ?? '';
    key.create_date = data?.create_date ?? '';
    return key;
  }

  static fromJsonList(data: any[]): SftpKey[] {
    return (data ?? []).map(SftpKey.fromJson);
  }
}

export class SftpSettings {
  sftp_user: string;
  sftp_host: string;
  keys: SftpKey[];

  constructor() {
    this.sftp_user = '';
    this.sftp_host = '';
    this.keys = [];
  }

  static fromJson(data: any): SftpSettings {
    const settings = new SftpSettings();
    settings.sftp_user = data?.sftp_user ?? '';
    settings.sftp_host = data?.sftp_host ?? '';
    settings.keys = SftpKey.fromJsonList(data?.keys);
    return settings;
  }
}
